export default {
  'tabs.close.left': '关闭左侧',
  'tabs.close.right': '关闭右侧',
  'tabs.close.others': '关闭其他',
  'tabs.refresh': '刷新',
}
